(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adeline-a11y-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const KEY = 'adeline-cookie-notice-ok';
    const init = () => {
      const box = document.querySelector('[data-adeline-cookie-notice]');
      if (!box) return;
      let seen = false;
      try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
      if (seen) return;
      const markSeen = () => { try { localStorage.setItem(KEY, '1'); } catch (e) {} };
      /* באנר העוגיות של שופיפיי על המסך או עומד להופיע */
      const shopifyBanner = () => {
        if (document.querySelector('[id^="shopify-pc__"]')) return true;
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        try { return Boolean(cp && cp.shouldShowBanner && cp.shouldShowBanner()); } catch (e) { return false; }
      };
      let tries = 0;
      const decide = () => {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!(cp && cp.shouldShowBanner) && ++tries < 30) { setTimeout(decide, 100); return; }
        if (!shopifyBanner()) box.hidden = false;
      };
      decide();
      new MutationObserver(() => { if (shopifyBanner()) box.hidden = true; }).observe(document.body, { childList: true });
      document.addEventListener('visitorConsentCollected', () => { box.hidden = true; markSeen(); });
      box.querySelector('[data-adeline-cookie-ok]').addEventListener('click', () => {
        markSeen();
        box.hidden = true;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-cart-styling"] && !Shopify.designMode) return;
  try {
    class AdelineCartStyling extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('submit', event => this.addItem(event), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async addItem(event) {
      const form = event.target;
      if (!form.matches('[data-styling-form]')) return;
      event.preventDefault();
      if (this.busy || !form.reportValidity()) return;
      this.busy = true;
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      const status = this.querySelector('[role="status"]');
      status.textContent = this.dataset.wait;
      let deferred;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const variantId = new FormData(form).get('id');
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0, 5);
        deferred = CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(() => {});
        form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections, sections_url: location.pathname }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('Cart addition failed');
        const cartResponse = await fetch(this.dataset.cartUrl);
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: result.sections, source: 'adeline-styling', sourceId: variantId, didError: false } });
        status.textContent = '';
      } catch (error) { deferred?.reject(error); status.textContent = this.dataset.error; }
      finally { this.busy = false; this.querySelectorAll('button').forEach(button => button.disabled = false); }
    }
  }
  if (!customElements.get('adeline-cart-styling')) customElements.define('adeline-cart-styling', AdelineCartStyling);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-experience"] && !Shopify.designMode) return;
  try {
    class AdelineExperience extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.saved = this.readSaved();
      this.wishlist = this.querySelector('#AdelineWishlist');
      this.lifti = this.querySelector('#AdelineLifti');
      this.liftiCloseLabel = this.lifti?.querySelector('[data-adeline-close]')?.getAttribute('aria-label');
      this.initialPrice = this.querySelector('[data-adeline-lifti-price]')?.textContent || '';
      this.initialCompare = this.querySelector('[data-adeline-lifti-compare]')?.textContent || '';
      this.initialCompareHidden = this.querySelector('[data-adeline-lifti-compare]')?.hidden ?? true;
      document.addEventListener('click', (event) => this.onClick(event), { ...options, capture: true });
      this.querySelector('[data-adeline-lifti-form]')?.addEventListener('submit', (event) => this.addLifti(event), options);
      this.querySelector('#AdelineLiftiVariant')?.addEventListener('change', (event) => {
        const option = event.target;
        if (!option.matches('input[name="id"]')) return;
        this.querySelector('[data-adeline-lifti-price]').textContent = option.dataset.price;
        this.querySelector('[data-adeline-lifti-button-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-adeline-lifti-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }, options);
      window.addEventListener('storage', () => { this.saved = this.readSaved(); this.syncButtons(); }, options);
      this.observer = new MutationObserver(() => this.syncButtons());
      this.observer.observe(document.querySelector('.page-wrapper') || document.body, { childList: true, subtree: true });
      this.syncButtons();
    }

    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }

    readSaved() {
      try {
        const value = JSON.parse(localStorage.getItem('adeline-wishlist-v1') || '[]');
        return Array.isArray(value) ? value.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string').slice(0, 100) : [];
      } catch { return []; }
    }

    persist() {
      try { localStorage.setItem('adeline-wishlist-v1', JSON.stringify(this.saved)); } catch { }
      this.syncButtons();
    }

    syncButtons() {
      document.querySelectorAll('[data-adeline-save]').forEach(button => {
        const active = String(this.saved.some(item => item.handle === button.dataset.handle));
        if (button.getAttribute('aria-pressed') !== active) button.setAttribute('aria-pressed', active);
      });
    }

    renderWishlist() {
      const list = this.querySelector('[data-adeline-wishlist-items]');
      list.replaceChildren();
      if (!this.saved.length) { const empty = document.createElement('p'); empty.textContent = this.dataset.emptyLabel; list.append(empty); return; }
      for (const item of this.saved) {
        const row = document.createElement('div'); row.className = 'adeline-wishlist-item';
        const img = document.createElement('img'); img.alt = item.title; img.loading = 'lazy';
        try { const url = new URL(item.image, location.origin); if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.origin === location.origin)) img.src = url.href; } catch { }
        const link = document.createElement('a'); link.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(item.handle)}`; link.textContent = item.title;
        const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.adelineRemove = item.handle; remove.textContent = '×'; remove.setAttribute('aria-label', `${this.dataset.removeLabel}: ${item.title}`);
        row.append(img, link, remove); list.append(row);
      }
    }

    async onClick(event) {
      if (!(event.target instanceof Element)) return;
      const save = event.target.closest('[data-adeline-save]');
      if (save) {
        event.preventDefault(); event.stopPropagation();
        if (this.saved.some(item => item.handle === save.dataset.handle)) this.saved = this.saved.filter(item => item.handle !== save.dataset.handle);
        else this.saved.push({ handle: save.dataset.handle, title: save.dataset.title, image: save.dataset.image || '' });
        this.saved = this.saved.slice(-100); this.persist(); return;
      }
      if (event.target.closest('[data-adeline-wishlist-open]')) { event.preventDefault(); this.renderWishlist(); this.wishlist.showModal(); return; }
      const remove = event.target.closest('[data-adeline-remove]');
      if (remove) { this.saved = this.saved.filter(item => item.handle !== remove.dataset.adelineRemove); this.persist(); this.renderWishlist(); return; }
      const close = event.target.closest('[data-adeline-close]');
      if (close) {
        const dialog = close.closest('dialog');
        if (dialog === this.lifti && this.adding) return;
        dialog.close();
        if (dialog === this.lifti && this.checkoutButton) this.continueCheckout();
        return;
      }
      if (event.target.closest('[data-adeline-skip]')) { this.lifti?.close(); this.continueCheckout(); return; }
      if (event.target.closest('[data-adeline-lifti-open]')) { this.checkoutButton = null; this.openLifti(); return; }
      const checkout = event.target.closest('button[name="checkout"]');
      if (!checkout || this.bypassCheckout || !this.lifti || !document.querySelector('[data-adeline-lifti-eligible]')) return;
      event.preventDefault(); event.stopPropagation();
      if (this.checking) return;
      this.checking = true; this.checkoutButton = checkout;
      try {
        const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (cart.items.some(item => item.handle === 'lifti-promo-offer') || !cart.items.length) this.continueCheckout();
        else this.openLifti();
      } catch { this.continueCheckout(); }
      finally { this.checking = false; }
    }

    openLifti() {
      if (!this.lifti) return;
      const form = this.lifti.querySelector('form'); form.reset();
      this.lifti.querySelector('[data-adeline-lifti-price]').textContent = this.initialPrice;
      const compare = this.lifti.querySelector('[data-adeline-lifti-compare]');
      compare.textContent = this.initialCompare;
      compare.hidden = this.initialCompareHidden;
      const button = form.querySelector('button[type="submit"]');
      button.querySelector('[data-adeline-lifti-cta]').textContent = this.checkoutButton ? button.dataset.continueLabel : button.dataset.addLabel;
      button.querySelector('[data-adeline-lifti-button-price]').textContent = this.initialPrice;
      this.lifti.querySelector('[data-adeline-skip]').hidden = !this.checkoutButton;
      this.lifti.querySelector('[data-adeline-close]').setAttribute('aria-label', this.checkoutButton ? this.lifti.querySelector('[data-adeline-skip]').textContent.trim() : this.liftiCloseLabel);
      this.lifti.querySelector('[data-adeline-lifti-status]').textContent = '';
      this.lifti.showModal();
    }

    continueCheckout() {
      const target = this.checkoutButton; this.checkoutButton = null;
      if (!target) return;
      this.bypassCheckout = true;
      const current = target.isConnected ? target : document.querySelector('button[name="checkout"]');
      current?.click(); this.bypassCheckout = false;
    }

    async addLifti(event) {
      event.preventDefault();
      if (this.adding) return;
      const form = event.target;
      if (!form.reportValidity()) return;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-adeline-lifti-status]');
      const variantId = form.querySelector('[name="id"]:checked').value;
      this.adding = true; button.disabled = true; status.textContent = this.dataset.waitLabel;
      let deferred;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(element => element.dataset.sectionId))].slice(0, 5);
        const cartResponse = await fetch(this.dataset.cartUrl, { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const currentCart = await cartResponse.json();
        if (currentCart.items.some(item => item.handle === 'lifti-promo-offer')) { this.lifti.close(); this.continueCheckout(); return; }
        deferred = CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(() => {});
        form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
        const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections, sections_url: location.pathname }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorLabel);
        const updatedResponse = await fetch(this.dataset.cartUrl, { credentials: 'same-origin' });
        if (!updatedResponse.ok) throw new Error(this.dataset.errorLabel);
        const cart = await updatedResponse.json();
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: result.sections, source: 'adeline-experience', sourceId: 'adeline-lifti', didError: false } });
        status.textContent = this.dataset.addedLabel;
        this.lifti.close(); this.continueCheckout();
      } catch (error) { deferred?.reject(error); status.textContent = this.dataset.errorLabel; }
      finally { this.adding = false; button.disabled = false; }
    }
  }
  if (!customElements.get('adeline-experience')) customElements.define('adeline-experience', AdelineExperience);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-fixes"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.adelineFixes) return;
    window.adelineFixes = true;

    /* 1. Quick-add: require an explicit size */
    const SIZE = /^(מידה|מידות|size|מידת קאפ|cup size)$/i;
    let confirmed = true;
    let observer = null;
    const modal = () => document.getElementById('quick-add-modal-content');
    const sizeInputs = (root) => [...root.querySelectorAll('variant-picker input[type="radio"]')].filter((input) => SIZE.test((input.dataset.optionName || '').trim()));
    const promptFor = (root) => {
      const picker = root.querySelector('variant-picker');
      if (!picker) return null;
      let prompt = root.querySelector('[data-adeline-quick-size-prompt]');
      if (!prompt) {
        prompt = document.createElement('p');
        prompt.setAttribute('data-adeline-quick-size-prompt', '');
        prompt.className = 'adeline-quick-size-prompt';
        prompt.setAttribute('role', 'alert');
        prompt.tabIndex = -1;
        prompt.textContent = 'נא לבחור מידה';
        prompt.hidden = true;
      }
      if (prompt.nextElementSibling !== picker) picker.before(prompt);
      return prompt;
    };
    const clearSizes = () => {
      const root = modal();
      if (!root || confirmed) return;
      const inputs = sizeInputs(root);
      if (inputs.length < 2) return;
      inputs.forEach((input) => { if (input.checked) input.checked = false; });
      promptFor(root);
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('.quick-add__button--choose')) return;
      confirmed = false;
      const root = modal();
      if (!root) return;
      root.querySelector('[data-adeline-quick-size-prompt]')?.setAttribute('hidden', '');
      if (!observer) {
        observer = new MutationObserver(clearSizes);
        observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked'] });
      }
    }, true);
    const guard = (event) => {
      const root = modal();
      if (!root || confirmed || !(event.target instanceof Element) || !root.contains(event.target)) return;
      const buying = event.type === 'submit' || event.target.closest('.add-to-cart-button, button[name="add"], button[type="submit"]');
      if (!buying || sizeInputs(root).length < 2) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const prompt = promptFor(root);
      if (prompt) {
        prompt.hidden = false;
        prompt.focus({ preventScroll: true });
        prompt.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    };
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);
    document.addEventListener('change', (event) => {
      const root = modal();
      const input = event.target;
      if (!root || !(input instanceof HTMLInputElement) || !root.contains(input) || !event.isTrusted) return;
      if (!SIZE.test((input.dataset.optionName || '').trim())) return;
      confirmed = true;
      root.querySelector('[data-adeline-quick-size-prompt]')?.setAttribute('hidden', '');
    }, true);

    /* 2. Homepage rows: a "view all" link after the products too */
    const addBottomLinks = () => {
      document.querySelectorAll('.adeline-curated-home').forEach((section) => {
        const content = section.querySelector('.section-resource-list__content');
        const top = section.querySelector('.section-resource-list__header a[href]');
        if (!content || !top || content.querySelector('a[href]')) return;
        const link = top.cloneNode(true);
        link.removeAttribute('id');
        link.classList.add('adeline-view-all-bottom');
        content.append(link);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addBottomLinks, { once: true });
    else addBottomLinks();

    /* 5. LIFTI checkout offer: once per session, no X in checkout mode */
    const LIFTI_KEY = 'adeline-lifti-offered';
    const offered = () => { try { return sessionStorage.getItem(LIFTI_KEY) === '1'; } catch { return false; } };
    window.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('button[name="checkout"]') || !offered()) return;
      const experience = document.querySelector('adeline-experience');
      if (!experience || experience.bypassCheckout) return;
      experience.bypassCheckout = true;
      setTimeout(() => { experience.bypassCheckout = false; }, 0);
    }, true);
    const watchLifti = () => {
      const dialog = document.getElementById('AdelineLifti');
      if (!dialog || dialog.dataset.adelineWatched) return;
      dialog.dataset.adelineWatched = '1';
      new MutationObserver(() => {
        if (!dialog.open) return;
        const skip = dialog.querySelector('[data-adeline-skip]');
        const checkoutMode = Boolean(skip && !skip.hidden);
        dialog.toggleAttribute('data-checkout-mode', checkoutMode);
        if (checkoutMode) { try { sessionStorage.setItem(LIFTI_KEY, '1'); } catch { } }
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchLifti, { once: true });
    else watchLifti();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-hero-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('adeline-hero-video')) {
    customElements.define('adeline-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.toggle = this.querySelector('[data-hero-toggle]');
        this.toggle?.addEventListener('click', (event) => {
          event.preventDefault(); event.stopPropagation();
          this.userPaused = !this.userPaused;
          this.toggleAttribute('data-user-paused', this.userPaused);
          this.toggle.setAttribute('aria-pressed', String(this.userPaused));
          this.toggle.setAttribute('aria-label', this.userPaused ? 'הפעלת הווידאו' : 'עצירת הווידאו');
          if (this.userPaused) this.video.pause(); else start();
        }, {signal});
        const start = () => {
          if (this.motion.matches || document.hidden || this.userPaused) { this.video.pause(); return; }
          this.video.muted = true;
          if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
          this.video.play().catch(() => this.removeAttribute('data-playing'));
        };
        this.video.addEventListener('playing', () => {
          const reveal = () => { if (this.isConnected && !this.video.paused) { this.setAttribute('data-playing', ''); if (this.toggle) this.toggle.hidden = false; } };
          if (this.video.requestVideoFrameCallback) this.video.requestVideoFrameCallback(reveal);
          else requestAnimationFrame(reveal);
        }, {signal});
        this.video.addEventListener('error', () => this.removeAttribute('data-playing'), {signal});
        this.motion.addEventListener('change', start, {signal});
        document.addEventListener('visibilitychange', start, {signal});
        this.observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) start(); else this.video.pause(); }, {threshold:0.05});
        this.observer.observe(this);
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const main = document.querySelector('#MainContent');
    if (!main || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const seen = new WeakSet();
    const animations = new Map();
    const selector = '.section-resource-list__header, .resource-list__item, .collection-card, .adeline-testimonials__header, .adeline-editorial__content';
    const observer = new IntersectionObserver(entries => {
      let sequence = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        if (preference.matches || entry.target.contains(document.activeElement)) continue;
        const animation = entry.target.animate([
          { opacity: .2, transform: 'translateY(16px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 580, delay: Math.min(sequence++ * 55, 165), easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' });
        animations.set(entry.target, animation);
        animation.finished.catch(() => {}).finally(() => animations.delete(entry.target));
      }
    }, { threshold: .08 });
    const scan = root => {
      if (preference.matches || !main.dataset.template?.startsWith('index')) return;
      root.querySelectorAll(selector).forEach(element => {
        if (seen.has(element)) return;
        seen.add(element);
        const bounds = element.getBoundingClientRect();
        if (!bounds.height || bounds.top < innerHeight) return;
        observer.observe(element);
      });
    };
    scan(main);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll(selector).forEach(element => {
        observer.unobserve(element);
        animations.get(element)?.cancel();
      });
    });
    document.addEventListener('focusin', event => {
      for (const [element, animation] of animations) {
        if (element.contains(event.target)) animation.cancel();
      }
    });
    preference.addEventListener('change', () => {
      observer.disconnect();
      for (const animation of animations.values()) animation.cancel();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-pdp-look"] && !Shopify.designMode) return;
  try {
    class AdelineLookBuilder extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const o = { signal: this.ac.signal };
      this.picked = {};
      this.cta = this.querySelector('.lk-cta');
      this.status = this.querySelector('.lk-status');
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('.lk-tab');
        if (tab) return this.showTab(tab);
        const pick = e.target.closest('.lk-pick');
        if (pick) return this.toggle(pick.closest('.lk-card'));
        if (e.target.closest('.lk-cta')) this.addLook();
      }, o);
      this.addEventListener('keydown', (e) => {
        const tab = e.target.closest('.lk-tab');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        const tabs = [...this.querySelectorAll('.lk-tab')];
        let i = tabs.indexOf(tab);
        const rtl = getComputedStyle(this).direction === 'rtl';
        if (e.key === 'Home') i = 0; else if (e.key === 'End') i = tabs.length - 1;
        else i = (i + (((e.key === 'ArrowLeft') !== rtl) ? -1 : 1) + tabs.length) % tabs.length;
        e.preventDefault(); tabs[i].focus(); this.showTab(tabs[i]);
      }, o);
      this.addEventListener('change', (e) => {
        if (e.target.matches('.lk-size')) { e.target.classList.remove('lk-need'); this.status.textContent = ''; this.render(); }
      }, o);
    }
    disconnectedCallback() { this.ac?.abort(); }
    showTab(tab) {
      this.querySelectorAll('.lk-tab').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      this.querySelectorAll('.lk-panel').forEach((p) => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
    }
    toggle(card) {
      const cat = card.dataset.cat;
      const prev = this.picked[cat];
      if (prev) this.setCard(prev, false);
      if (prev === card) delete this.picked[cat];
      else { this.picked[cat] = card; this.setCard(card, true); }
      this.status.textContent = '';
      this.render();
      /* after picking, move gently to the next empty tab */
      if (this.picked[cat] && !card.querySelector('.lk-size')) {
        const next = [...this.querySelectorAll('.lk-tab')].find((t) => !this.picked[t.dataset.tab] && t.dataset.tab !== cat);
        if (next && Object.keys(this.picked).length < 3) setTimeout(() => this.showTab(next), 420);
      }
    }
    setCard(card, on) {
      card.querySelector('.lk-pick').setAttribute('aria-pressed', String(on));
      const sel = card.querySelector('.lk-size');
      if (sel) { sel.hidden = !on; if (on && !sel.value) sel.focus({ preventScroll: true }); }
    }
    money(c) {
      const v = Math.round(c) / 100;
      return (Number.isInteger(v) ? v.toLocaleString('he-IL') : v.toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + ' ₪';
    }
    render() {
      const cards = Object.values(this.picked);
      this.querySelectorAll('.lk-tab').forEach((t) => t.toggleAttribute('data-has', !!this.picked[t.dataset.tab]));
      const sum = this.querySelector('.lk-sum');
      sum.toggleAttribute('data-empty', cards.length === 0);
      sum.querySelector('.lk-sum__thumbs').innerHTML = cards.map((c) => c.dataset.img ? '<img src="' + c.dataset.img + '" alt="" width="38" height="38" loading="lazy">' : '').join('');
      const total = cards.reduce((s, c) => s + Number(c.dataset.final), 0);
      const full = cards.reduce((s, c) => s + Number(c.dataset.price), 0);
      sum.querySelector('[data-line]').textContent = cards.length
        ? (cards.length === 1 ? 'פריט אחד' : cards.length + ' פריטים') + ' · ' + this.money(total)
        : 'בחרי עגילים, תיק ונעליים';
      sum.querySelector('[data-save]').textContent = full - total > 0 ? 'חוסכת ' + this.money(full - total) + ' עם השמלה' : '';
      this.cta.disabled = cards.length === 0;
      this.cta.querySelector('.lk-cta__label').textContent = cards.length > 1 ? 'הוספת הלוק לסל' : 'הוספה לסל';
    }
    async addLook() {
      if (this.busy) return;
      const cards = Object.values(this.picked);
      if (!cards.length) return;
      const lines = [];
      for (const c of cards) {
        const sel = c.querySelector('.lk-size');
        const id = sel ? sel.value : c.dataset.variant;
        if (!id) {
          this.showTab(this.querySelector('.lk-tab[data-tab="' + c.dataset.cat + '"]'));
          sel.classList.remove('lk-need'); void sel.offsetWidth; sel.classList.add('lk-need');
          sel.focus();
          this.status.textContent = 'נשאר לבחור מידה עבור ' + c.dataset.title;
          return;
        }
        lines.push({ id: Number(id), quantity: 1 });
      }
      this.busy = true;
      this.status.textContent = '';
      let deferred;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((n) => n.dataset.sectionId))].slice(0, 5);
        deferred = CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(() => {});
        this.cta.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: 1 })), promise: deferred.promise }));
        const res = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines, sections, sections_url: location.pathname }) });
        const result = await res.json();
        if (!res.ok || result.status) throw new Error(result.description || 'add failed');
        const cartRes = await fetch(this.dataset.cartUrl);
        const cart = await cartRes.json();
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: result.sections, source: 'adeline-look', sourceId: String(lines[0].id), didError: false } });
        cards.forEach((c) => this.setCard(c, false));
        this.picked = {};
        setTimeout(() => this.render(), 1700);
      } catch (err) {
        deferred?.reject(err);
        this.status.textContent = (err && err.message && /[֐-׿]/.test(err.message)) ? err.message : this.dataset.error;
      } finally { this.busy = false; }
    }
  }
  if (!customElements.get('adeline-look-builder')) customElements.define('adeline-look-builder', AdelineLookBuilder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-shipping-protection"] && !Shopify.designMode) return;
  try {
    class AdelineShippingProtection extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[role="switch"]');
      this.input?.addEventListener('change', () => this.toggle());
    }
    async toggle() {
      const on = this.input.checked;
      this.input.disabled = true;
      this.input.setAttribute('aria-checked', String(on));
      const status = this.querySelector('[role="status"]');
      status.textContent = 'מעדכנים את הסל…';
      let deferred;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0, 5);
        const variantId = Number(this.dataset.variantId);
        let response;
        if (on) {
          response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections, sections_url: location.pathname }) });
        } else {
          const cart = await fetch(this.dataset.cartUrl).then(r => r.json());
          const line = cart.items.find(item => item.variant_id === variantId);
          if (!line) { status.textContent = ''; return; }
          response = await fetch(this.dataset.changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0, sections, sections_url: location.pathname }) });
        }
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('Cart update failed');
        const cart = await fetch(this.dataset.cartUrl).then(r => r.json());
        deferred = CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(() => {});
        this.dispatchEvent(new CartLinesUpdateEvent({ action: on ? 'add' : 'remove', context: 'cart', lines: [{ merchandiseId: variantId, quantity: on ? 1 : 0 }], promise: deferred.promise }));
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: result.sections, source: 'adeline-shipping-protection', sourceId: String(variantId), didError: false } });
        status.textContent = '';
      } catch (error) {
        deferred?.reject(error);
        this.input.checked = !on;
        this.input.setAttribute('aria-checked', String(!on));
        status.textContent = 'לא הצלחנו לעדכן את הסל. נסי שוב.';
      } finally {
        this.input.disabled = false;
      }
    }
  }
  if (!customElements.get('adeline-shipping-protection')) customElements.define('adeline-shipping-protection', AdelineShippingProtection);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adeline-text-style"] && !Shopify.designMode) return;
  try {
    class AdelineTextStyle extends HTMLElement {
    connectedCallback() {
      const normalize = node => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (!node.parentElement?.closest('script,style,textarea,code,pre,[contenteditable]') && /[–—]/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/[–—]/g, '-');
          return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE || node.matches('script,style,textarea,code,pre,[contenteditable]')) return;
        for (const attr of ['aria-label','alt','title']) {
          const value = node.getAttribute(attr);
          if (value && /[–—]/.test(value)) node.setAttribute(attr, value.replace(/[–—]/g, '-'));
        }
        node.childNodes.forEach(normalize);
      };
      normalize(document.body);
      this.observer = new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'characterData' || record.type === 'attributes') normalize(record.target);
          else record.addedNodes.forEach(normalize);
        }
      });
      this.observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label','alt','title'] });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  if (!customElements.get('adeline-text-style')) customElements.define('adeline-text-style', AdelineTextStyle);
  } catch(e) { console.error(e); }
})();

})();
